import React from 'react'
import PropTypes from 'prop-types'

import s from './SidebarSection.scss'


const SidebarSection = ({ children, dataTestId }) => (
  <div className={s.section} data-testid={dataTestId}>{children}</div>
)

SidebarSection.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string,
}


export default SidebarSection
